import React, {useState, useEffect} from "react";
import {slice} from "lodash";
import {useParams} from "react-router-dom";
import {Link} from "react-router-dom";
import InnerBanner from "../components/InnerBanner";
import Helmet from "react-helmet";

export default function TravelPackagesCraft() {
  const params = useParams();
  console.log(params.loc);
  const [apilink] = useState("../databases/packagesCraft.json");
  //const [apilink, setApilink] = useState([])
  const [post, setPost] = useState([]);
  //const [ setIsCompleted] = useState(false);
  const [index] = useState();
  let initialPosts = slice(post, 0, index);
  const getData = (apilink) => {
    fetch(apilink)
      .then((res) => res.json())
      .then((json) => setPost(json))
      .catch((e) => console.log(e));
  };

  useEffect(() => {
    getData(apilink);
  }, [apilink]);

  initialPosts = initialPosts.filter(
    (item) => item.destinationname === params.loc
  );
  return (
    <>
     {initialPosts.map((item, i) => {
              return (
                <React.Fragment key={item.id}>
               <Helmet>
               
               <title>{item.title}</title>
               
           </Helmet>

                <InnerBanner imgPath={item.listing_page_banner} innerTitle={item.listing_page_banner_heading} />
      <section className="allPackages">
        <div className="container">
          <div className="row">
           
                  {item.packages.map((itemm, j) => {
                    return (
                      <div className={`${itemm.widthClass} rel`}>
                        <div className="pricing">{itemm.pricing}</div>
                        <div className="subTrend">
                          <img
                            className="trendImg"
                            src={itemm.imagePath}
                            alt=""
                          />
                          <div className="trendDetail">
                            <h3>{itemm.packname}</h3>
                            <div className="packDetail">
                              <span>
                                <img src="../assets/img/loc-pin.png" alt="" />{" "}
                                {itemm.displaylocation}
                              </span>
                              <span>
                                <img src="../assets/img/time-ic.png" alt="" />{" "}
                                {itemm.duration}{" "}
                              </span>
                            </div>
                            {/* <p>{itemm.description}</p> */}
                            <p dangerouslySetInnerHTML={ { __html: itemm.description } }></p>
                            <Link
                              to={`/PackageDetailCraft/${itemm.location}/${itemm.pack_url}`}
                              className="packCta"
                            >
                              View Detail
                            </Link>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                
          </div>
        </div>
      </section>
      </React.Fragment>
              );
            })}
    </>
  );
}
